import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Chip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Chip';
import FormattedTooltip from 'Components/ComponentLibrary/Atoms/Tooltips/FormattedTooltip';
import { FACET_COLORS } from 'Theme';
import { ArrowDownward, ArrowUpward, Check } from '@material-ui/icons';
import PropTypes from 'prop-types';

const useStyles = buildUseStyles('InsightChip', (() => ({
  root: {},
  chip: {},
  icon: {},
})));

const getIconType = (resource) => {
  switch (resource.attr('iconType')) {
    case 'arrow_downward':
      return ArrowDownward;
    case 'arrow_upward':
      return ArrowUpward;
    case 'check':
      return Check;
    default:
      return React.Fragment;
  }
};

const getBackgroundColor = (resource) => {
  switch (resource.attr('status')) {
    case 'SUCCESS':
      return FACET_COLORS.blueGray4.color;
    case 'WARN':
      return FACET_COLORS.yellow.color;
    case 'ERROR':
      return FACET_COLORS.yellow.color;
    default:
      return FACET_COLORS.blueGray4.color;
  }
};

const getTextColor = (resource) => {
  switch (resource.attr('status')) {
    case 'SUCCESS':
      return FACET_COLORS.blueGray4.contrast;
    case 'WARN':
      return FACET_COLORS.yellow.contrast;
    case 'ERROR':
      return FACET_COLORS.yellow.contrast;
    default:
      return FACET_COLORS.blueGray4.contrast;
  }
};

const InsightChip = ({
  insightResource,
}) => {
  const classes = useStyles();

  const Icon = getIconType(insightResource);
  const backgroundColor = getBackgroundColor(insightResource);
  const textColor = getTextColor(insightResource);

  return (
    <FormattedTooltip
      title={insightResource.attr('description')}
    >
      <Chip
        className={classes.chip}
        style={{ backgroundColor, color: textColor }}
        label={insightResource.attr('name')}
        icon={<Icon className={classes.icon} style={{ color: textColor }} />}
        test={`scenario-outcome-insight-chip-${insightResource.id()}`}
      />
    </FormattedTooltip>
  );
};

InsightChip.defaultProps = {
};

InsightChip.propTypes = {
  insightResource: PropTypes.object.isRequired,
};

export default InsightChip;
